import {
  signalStoreFeature,
  patchState,
  withState,
  withMethods,
} from '@ngrx/signals';

interface StoreEvent {
  type: string;
  payload?: any;
}

interface EventState {
  lastEvent: StoreEvent | null;
}

export function withEventBroadcasting() {
  return signalStoreFeature(
    withState<EventState>({ lastEvent: null }),
    withMethods(store => {
      return {
        broadcastEvent(event: StoreEvent) {
          // Patch state to trigger signal update
          patchState(store, { lastEvent: event });
        },
      };
    })
  );
}
